import {
  OrderFilters, OrderFiltersFragment, ParticipantFilters, ParticipantFiltersFragment, PurchaseFilters,
  PurchaseFiltersFragment, RegistrationFilters, RegistrationFiltersFragment,
} from '__generated__/graphql';

export const getOrderFiltersInput = (filters: OrderFiltersFragment): OrderFilters => ({
  events: filters.events || [],
  participant_fields: filters.participant_fields?.map(({ id, filters }) => ({
    id,
    filters: {
      min: filters?.min,
      max: filters?.max,
    },
  })) || [],
  participant_field_choices: filters.participant_field_choices || [],
});

export const getParticipantFiltersInput = (filters: ParticipantFiltersFragment): ParticipantFilters => ({
  events: filters.events || [],
  locales: filters.locales || [],
  mail_opt_ins: filters.mail_opt_ins || [],
});

export const getPurchaseFiltersInput = (filters: PurchaseFiltersFragment): PurchaseFilters => ({
  events: filters.events || [],
  ticket_categories: filters.ticket_categories || [],
  tickets: filters.tickets || [],
  time_slots: filters.time_slots || [],
  ticket_number_sequences: filters.ticket_number_sequences || [],
  has_ticket_number: typeof filters.has_ticket_number === 'boolean' ? filters.has_ticket_number : null,
  assigned: typeof filters.assigned === 'boolean' ? filters.assigned : null,
  products: filters.products || [],
  product_variants: filters.product_variants || [],
  promotions: filters.promotions || [],
  participant_fields: filters.participant_fields?.map(({ id, filters }) => ({
    id,
    filters: {
      min: filters?.min,
      max: filters?.max,
    },
  })) || [],
  participant_field_choices: filters.participant_field_choices || [],
  invitations: filters.invitations || [],
  coupons: filters.coupons || [],
  lotteries: filters.lotteries || [],
  confirmed_lotteries: filters.confirmed_lotteries || [],
  rejected_lotteries: filters.rejected_lotteries || [],
  statuses: filters.statuses || [],
  payment_statuses: filters.payment_statuses || [],
});

export const getRegistrationFiltersInput = (filters: RegistrationFiltersFragment): RegistrationFilters => ({
  events: filters.events || [],
  ticket_categories: filters.ticket_categories || [],
  tickets: filters.tickets || [],
  time_slots: filters.time_slots || [],
  ticket_number_sequences: filters.ticket_number_sequences || [],
  has_ticket_number: typeof filters.has_ticket_number === 'boolean' ? filters.has_ticket_number : null,
  has_team: typeof filters.has_team === 'boolean' ? filters.has_team : null,
  assigned: typeof filters.assigned === 'boolean' ? filters.assigned : null,
  products: filters.products || [],
  product_variants: filters.product_variants || [],
  promotions: filters.promotions || [],
  participant_fields: filters.participant_fields?.map(({ id, filters }) => ({
    id,
    filters: {
      min: filters?.min,
      max: filters?.max,
    },
  })) || [],
  participant_field_choices: filters.participant_field_choices || [],
  invitations: filters.invitations || [],
  coupons: filters.coupons || [],
  lotteries: filters.lotteries || [],
  confirmed_lotteries: filters.confirmed_lotteries || [],
  rejected_lotteries: filters.rejected_lotteries || [],
  statuses: filters.statuses || [],
  payment_statuses: filters.payment_statuses || [],
  genders: filters.genders || [],
  min_age: filters.min_age || null,
  max_age: filters.max_age || null,
});

export default undefined;
